import type { Vob } from '@finpay-estimation/estimation-types';

/** V3 VOB API expects `plan.planCode` as string. */
export function withVobPlanCodeAsString(vob: Vob): Vob {
  if (vob.plan?.planCode == null || typeof vob.plan.planCode === 'string') {
    return vob;
  }
  return {
    ...vob,
    plan: {
      ...vob.plan,
      planCode: String(vob.plan.planCode),
    },
  };
}
